const question = {
    yes: { point: [1] },
    no: { point: [3] },
};
export default question;
